import type { CpServiceId } from "@climatepartner/utils";

export const APP_SERVICE_IDS = {
  ANALYTICS: "analytics.basic",
  CFC: "cfc",
  COMMUNICATION: "transparency-dashboard-frontend",
  COMMUNICATION_REPORTS: "transparency.reports",
  CONTRIBUTE: "fpm",
  DOCUMENTS: "documents",
  HOMESCREEN: "homescreen",
  NETWORK: "network-v2",
  REDUCTION: "reduction-homepage-frontend",
} as const satisfies Record<string, CpServiceId>;
